<template>
  <div class="change-email-modal">
    <button class="btn btn--outline" @click="display=true">Change Email</button>
    <modal @close="display=false" v-if="display">
      <div slot="body">
        <form @submit.prevent="save">
          <div class="error" v-if="errorMessage">{{errorMessage}}</div>
          <input v-model="newEmail" label="New Email Address" required type="email"></input>
          <input v-model="confirm" label="Confirm Email Address" required type="email"></input>
          <h-btn type="submit" :disabled="saving">Submit</h-btn>
          <h-btn @click="display=false" flat :disabled="saving">Cancel</h-btn>
        </form>
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
import modal from "@/components/modal";
import store from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import User from "@/services/api/authUser";

export default {
  components: {
    modal
  },
  data() {
    return {
      display: false,
      errorMessage: "",
      newEmail: "",
      confirm: "",
      saving: false
    };
  },
  methods: {
    save() {
      if (this.newEmail !== this.confirm) {
        this.errorMessage = "Confirmation email does not match.";
        return;
      }
      this.saving = true;
      this.errorMessage = "";
      store
        .update(
          "User",
          User.id,
          { email: this.newEmail.toLowerCase().trim() },
          { method: "PATCH" }
        )
        .then(() => {
          snackbar.update("Saved");
          this.display = false;
          this.$emit("Update", this.newEmail);
        })
        .catch(({ response }) => {
          if (response.status == 400) {
            this.errorMessage = "That email address is already in use";
          } else if (response.status < 500) {
            this.errorMessage =
              "You do not have permission to perform this action";
          } else {
            this.errorMessage =
              "There was a server error. Our staff has been notified. Please try again later";
          }
        })
        .finally(() => (this.saving = false));
    }
  }
};
</script>

<style lang="less">
.change-email-modal {
  .error {
    padding: 5px;
    color: white;
  }
}
</style>
